import React from 'react';
import styled from 'styled-components';

import { useSpring, animated } from 'react-spring';
import { HashLink as Link } from 'react-router-hash-link';

const CollapseMenu = ({ handleNavbar, navbarState }) => {
  const { open } = useSpring({ open: navbarState ? 0 : 1 });

  if (navbarState === true) {
    return (
      <CollapseWrapper style={{
        transform: open.interpolate({
          range: [0, 0.2, 0.3, 1],
          output: [0, -20, 0, -200],
        }).interpolate((openValue) => `translate3d(0, ${openValue}px, 0`),
      }}
      >
        <NavLinks>
          <li>
            <Link smooth to="/" onClick={handleNavbar(true)}>Home</Link>
          </li>
          <li>
            <Link smooth to="/#services" onClick={handleNavbar(false)}>Services</Link>
          </li>
          <li>
            <Link smooth to="/#work" onClick={handleNavbar(false)}>Work</Link>
          </li>
          <li>
            <Link smooth to="/#clients" onClick={handleNavbar(false)}>Clients</Link>
          </li>
          <li>
            <Link smooth to="/#contact" onClick={handleNavbar(false)}>Contact</Link>
          </li>
          <li>
            <Link to="/about" onClick={handleNavbar(true)}>About</Link>
          </li>

        </NavLinks>
      </CollapseWrapper>
    );
  }
  return null;
};

export default CollapseMenu;

const CollapseWrapper = styled(animated.div)`
  background: #2d3436;
  position: fixed;
  top: 45px;
  left: 0;
  right: 0;
  z-index: 200;
`;

const NavLinks = styled.ul`
  list-style-type: none;
  padding: 0 15px;

  & li {
    text-align: center;
    transition: all 300ms linear 0s;
    padding: 5px 0;
    
    :not(:last-child) {
    border-bottom: rgba(108,108,108,0.2) solid 1px;
    }
  }

  & a {
    font-size: 14px;
    line-height: 2;
    color: #dfe6e9;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: #fdcb6e;
      border-bottom: 1px solid #fdcb6e;
    }
  }
`;
